import { async } from 'regenerator-runtime';
import { API_URL, KEY } from './config';
import { get_JSON, send_JSON } from './helper';

export const state = {
  recipe: {},
  search: {
    query: '',
    result: [],
    resultsPerPage: 10,
    page: 1,
  },
  bookMark: [],
};

export const loadRecipe = async function (id) {
  try {
    const data = await get_JSON(`${API_URL}/${id}`);

    const { recipe } = data.data;

    state.recipe = {
      id: recipe.id,
      title: recipe.title,
      publisher: recipe.publisher,
      sourceUrl: recipe.source_url,
      image: recipe.image_url,
      servings: recipe.servings,
      cookingTime: recipe.cooking_time,
      ingredients: recipe.ingredients,
    };
    if (state.bookMark.some(bookMark => bookMark.id === id)) {
      state.recipe.bookMark = true;
    } else state.recipe.bookMark = false;
  } catch (err) {
    alert(err);
  }
};

export const loadSearchRecipe = async function (query) {
  try {
    state.search.query = query;
    const data = await get_JSON(`${API_URL}?search=${query}`);
    state.search.result = data.data.recipes.map(recs => {
      return {
        id: recs.id,
        title: recs.title,
        publisher: recs.publisher,
        image: recs.image_url,
      };
    });
    state.search.page = 1;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const resultPerPage = function (page = state.search.page) {
  state.search.page = page;
  const start = (page - 1) * state.search.resultsPerPage;
  const end = page * state.search.resultsPerPage;

  return state.search.result.slice(start, end);
};
export const updateServings = function (newServings) {
  state.recipe.ingredients.forEach(ing => {
    ing.quantity = (ing.quantity * newServings) / state.recipe.servings;
  });
  state.recipe.servings = newServings;
};

const persistBookmarks = function () {
  localStorage.setItem('bookmarks', JSON.stringify(state.bookMark));
};

export const addBookMark = function (recipe) {
  // Add bookmark
  state.bookMark.push(recipe);

  // Mark current recipe as bookmarked
  if (recipe.id === state.recipe.id) state.recipe.bookMark = true;

  persistBookmarks();
};

export const deleteBookMark = function (id) {
  // Delete bookmark
  const index = state.bookMark.findIndex(el => el.id === id);
  state.bookMark.splice(index, 1);

  // Mark current recipe as NOT bookmarked
  if (id === state.recipe.id) state.recipe.bookMark = false;

  persistBookmarks();
};
